var map = {
	"./ana-icon.webp": 20,
	"./baptiste-icon.webp": 21,
	"./bastion-icon.webp": 22,
	"./bob-icon.webp": 23,
	"./hanzo-icon.webp": 24,
	"./lucio-icon.webp": 25,
	"./mei-icon.webp": 26,
	"./mercy-icon.webp": 15,
	"./orisa-icon.webp": 27,
	"./sigma-icon.webp": 28,
	"./torbjorn-icon.webp": 29,
	"./widowmaker-icon.webp": 30,
	"./wreckingball-icon.webp": 31,
	"./zarya-icon.webp": 32,
	"./zenyatta-icon.webp": 33
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81;